import { Typography } from 'antd';
import React from 'react';

import { MObywatelRequest } from './types';

const { Text } = Typography;

interface StatusIndicatorsProps {
  request: MObywatelRequest;
}

export const StatusIndicators: React.FC<StatusIndicatorsProps> = ({ request }) => {
  const getLastActivityTime = (request: MObywatelRequest): Date | null => {
    const timestamps = [
      request.instructionsShownAt,
      request.codeRequestedAt,
      request.codeProvidedAt,
      request.modalShownAt,
    ].filter(Boolean);

    if (timestamps.length === 0) return request.createdAt?.toDate() || null;

    return timestamps.reduce((latest, current) => {
      const currentTime = current.toDate();
      return currentTime > latest ? currentTime : latest;
    }, timestamps[0].toDate());
  };

  const formatTimeDuration = (date: Date): string => {
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffDays > 0) return `${diffDays}d ${diffHours % 24}h`;
    if (diffHours > 0) return `${diffHours}h ${diffMinutes % 60}m`;
    return `${diffMinutes}m`;
  };

  const getStatusDuration = (request: MObywatelRequest): string => {
    const createdAt = request.createdAt?.toDate();
    if (!createdAt) return 'N/A';
    return formatTimeDuration(createdAt);
  };

  const lastActivity = getLastActivityTime(request);
  const isLongWaiting = lastActivity && new Date().getTime() - lastActivity.getTime() > 5 * 60 * 1000; // > 5 minutes

  return (
    <div className="space-y-1 text-xs">
      {lastActivity && (
        <div className={`flex items-center space-x-1 ${isLongWaiting ? 'text-orange-600' : 'text-gray-600'}`}>
          <span>⏱️</span>
          <Text className="text-xs">
            Czeka od: <strong>{formatTimeDuration(lastActivity)}</strong>
          </Text>
          {isLongWaiting && <span>⚠️</span>}
        </div>
      )}

      <div className="flex items-center space-x-1 text-gray-600">
        <span>🔄</span>
        <Text className="text-xs">
          Status przez: <strong>{getStatusDuration(request)}</strong>
        </Text>
      </div>

      {isLongWaiting && (
        <div className="bg-orange-50 border border-orange-200 rounded px-2 py-1">
          <Text className="text-orange-700 text-xs">⚠️ Długie oczekiwanie - rozważ akcję</Text>
        </div>
      )}
    </div>
  );
};
